<mx-elevated-button label="Toggle Dark Theme" (click)="toggleDarkTheme()" class="m-8"/>

<mx-component-lib-section titleText="Accordion">
  <div class="flex flex-row gap-8">
    <mat-accordion multi class="w-[37.5rem]">
      <ng-container *ngTemplateOutlet="expansionPanelNoIcon"/>
      <ng-container *ngTemplateOutlet="expansionPanelNoIcon"/>
      <ng-container *ngTemplateOutlet="expansionPanelNoIcon"/>
    </mat-accordion>
    <mat-accordion multi class="w-[37.5rem]">
      <ng-container *ngTemplateOutlet="expansionPanelwIcon"/>
      <ng-container *ngTemplateOutlet="expansionPanelwIcon"/>
      <ng-container *ngTemplateOutlet="expansionPanelwIcon"/>
    </mat-accordion>
  </div>
</mx-component-lib-section>
<ng-template #expansionPanelNoIcon>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Heading
      </mat-panel-title>
      <mat-panel-description>
        Secondary Heading
      </mat-panel-description>
    </mat-expansion-panel-header>
    Content
  </mat-expansion-panel>
</ng-template>
<ng-template #expansionPanelwIcon>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Heading
      </mat-panel-title>
      <mat-panel-description>
        Secondary Heading
        <mat-icon class="ml-auto">person</mat-icon>
      </mat-panel-description>
    </mat-expansion-panel-header>
    Content
  </mat-expansion-panel>
</ng-template>

<mx-component-lib-badges/>

<!-- eslint-disable @nx/workspace-mx-use-button-components -- The anchors in here are for demo only.  They have no destinations. -->
<mx-component-lib-section titleText="Breadcrumb">
  <div class="flex flex-row gap-14">
    <div class="flex-col gap-8 w-80 text-body-medium">
      <div>
        <span><a>Dashboard</a></span>
        <span class="mx-4">/</span>
        <span>Link2</span>
      </div>
      <div>
        <span><a>Dashboard</a></span>
        <span class="mx-4">/</span>
        <span><a>Link1</a></span>
        <span class="mx-4">/</span>
        <span>Link2</span>
      </div>
      <div>
        <span><a>Dashboard</a></span>
        <span class="mx-4">.</span>
        <span><a>Link1</a></span>
        <span class="mx-4">.</span>
        <span>Link2</span>
      </div>
      <div>
        <span><a>Dashboard</a></span>
        <span class="mx-4">&gt;</span>
        <span><a>Link1</a></span>
        <span class="mx-4">&gt;</span>
        <span>Link2</span>
      </div>
    </div>
    <div class="flex-col gap-8 w-80 text-body-medium">
      <div>&nbsp;</div>
      <div>
        <span><a>Dashboard</a></span>
        <span class="mx-4">\</span>
        <span><a>Link1</a></span>
        <span class="mx-4">\</span>
        <span>Link2</span>
      </div>
      <div>
        <span><a>Dashboard</a></span>
        <span class="mx-4">;</span>
        <span><a>Link1</a></span>
        <span class="mx-4">;</span>
        <span>Link2</span>
      </div>
      <div>
        <span><a>Dashboard</a></span>
        <span class="mx-4">-</span>
        <span><a>Link1</a></span>
        <span class="mx-4">-</span>
        <span>Link2</span>
      </div>
    </div>
  </div>
</mx-component-lib-section>
<!-- eslint-enable @nx/workspace-mx-use-button-components -->

<div class="m-8 flex gap-8">
  <mx-elevated-button label="Toggle Dark Theme" (click)="toggleDarkTheme()"/>
</div>

<mx-component-lib-section titleText="Buttons">
  <mx-component-lib-buttons [useAviaryButtonComponents]="true"
                            [supportedButtonTypesByColor]="{
                              primary: ['filled', 'outlined', 'split', 'icon'],
                              secondary: ['text'],
                              error: ['outlined', 'icon'],
                              'on-surface-variant': ['icon']
                            }"/>
</mx-component-lib-section>

<mx-component-lib-section titleText="Cards">
  <mat-card class="w-[37.5rem]">
    <mat-card-title-group>
      <mat-card-title>Card Header</mat-card-title>
      <mat-card-subtitle class="mx-4">Subheader</mat-card-subtitle>
      <img mat-card-lg-image src="https://storage.googleapis.com/millonex-assets/img/landing/landing.webp" alt=""/>
    </mat-card-title-group>
    <mat-card-content>
      <div>Body</div>
    </mat-card-content>
    <mat-card-actions class="px-4 pb-4">
      <div class="flex-row place-content-end">
        <mx-text-button label="Action 1"/>
        <mx-text-button label="Action 2"/>
      </div>
    </mat-card-actions>
  </mat-card>
  <mat-card class="w-[37.5rem]">
    <mat-card-title-group>
      <mat-card-title>Card Header</mat-card-title>
      <mat-card-subtitle class="mx-4">
        <div>Body</div>
      </mat-card-subtitle>
      <img mat-card-lg-image src="https://storage.googleapis.com/millonex-assets/img/landing/landing.webp" alt=""/>
    </mat-card-title-group>

  </mat-card>
</mx-component-lib-section>

<mx-component-lib-checkboxes/>

<mx-component-lib-section titleText="Chips">
  <table class="bg-surface">
    <caption></caption>  <!-- To appease SonarLint. -->
    <th></th>  <!-- To appease SonarLint. -->

    <tr class="border bg-surface2">
      <td class="text-title-medium text-right px-3 border-r">Theme colors</td>
      <td class="p-3">
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mat-chip color="primary">primary</mat-chip>
          <mat-chip color="secondary">secondary</mat-chip>
          <mat-chip color="tertiary">tertiary</mat-chip>
          <mat-chip color="success">success</mat-chip>
          <mat-chip color="warn">warn</mat-chip>
          <mat-chip color="error">error</mat-chip>
          <mat-chip color="outline">outline</mat-chip>
          <mat-chip color="outline-variant">outline-variant</mat-chip>
          <mat-chip color="transparent">transparent</mat-chip>
          <mat-chip color="background">background</mat-chip>
        </mat-chip-set>
      </td>
    </tr>

    <tr class="border">
      <td class="text-title-medium text-right px-3 border-r">Patron type</td>
      <td class="p-3">
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mat-chip color="patron-category-default">Default</mat-chip>
          <mat-chip color="patron-category-1">Assigned Color 1</mat-chip>
          <mat-chip color="patron-category-2">Assigned Color 2</mat-chip>
          <mat-chip color="patron-category-3">Assigned Color 3</mat-chip>
          <mat-chip color="patron-category-4">Assigned Color 4</mat-chip>
          <mat-chip color="patron-category-5">Assigned Color 5</mat-chip>
        </mat-chip-set>
      </td>
    </tr>

    <tr class="border bg-surface2">
      <td class="text-title-medium text-right px-3 border-r">Status colors & widths</td>
      <td class="p-3">
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mat-chip color="status-neutral" class="mx-status-chip">neutral</mat-chip>
          <mat-chip color="status-inactive" class="mx-status-chip">inactive</mat-chip>
          <mat-chip color="status-transitional" class="mx-status-chip">transitional</mat-chip>
          <mat-chip color="status-negative" class="mx-status-chip">negative</mat-chip>
          <mat-chip color="status-positive" class="mx-status-chip">positive</mat-chip>
          <mat-chip color="status-transitional" class="mx-status-chip">enough text to cause widening</mat-chip>
        </mat-chip-set>
      </td>
    </tr>

    <tr class="border">
      <td class="text-title-medium text-right px-3 border-r">Item request status</td>
      <td class="p-3">
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mx-status-chip status="REQUESTED" [colors]="ITEM_REQUEST_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_ITEM_REQUEST_STATUS"/>
          <mx-status-chip status="PENDING" [colors]="ITEM_REQUEST_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_ITEM_REQUEST_STATUS"/>
          <mx-status-chip status="APPROVED" [colors]="ITEM_REQUEST_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_ITEM_REQUEST_STATUS"/>
          <mx-status-chip status="DECLINED" [colors]="ITEM_REQUEST_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_ITEM_REQUEST_STATUS"/>
          <mx-status-chip status="CANCELED" [colors]="ITEM_REQUEST_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_ITEM_REQUEST_STATUS"/>
        </mat-chip-set>
      </td>
    </tr>

    <tr class="border">
      <td class="text-title-medium text-right px-3 border-r">Hold status</td>
      <td class="flex flex-col gap-y-3 p-3">
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mx-status-chip status="HELD" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"
                          subscriptText="until 04/01/2024"/>
          <mx-status-chip status="REQUESTED" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"
                          subscriptText="#2 on 12 copies"/>
          <mx-status-chip status="TRANSIT" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"/>
          <mx-status-chip status="PULLED" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"/>
          <mx-status-chip status="PENDING" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"/>
        </mat-chip-set>
        <mat-divider/>
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mx-status-chip status="PAUSED" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"
                          subscriptText="until 04/01/2024"/>
          <mx-status-chip status="PICKED_UP" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"/>
          <mx-status-chip status="CANCELED" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"
                          subscriptText="on 04/01/2024"/>
          <mx-status-chip status="EXPIRED" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"/>
          <mx-status-chip status="UNCLAIMED" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"/>
          <mx-status-chip status="NOT_SUPPLIED" [colors]="HOLD_STATUS_CHIP_COLORS" [displayableStatusNames]="DISPLAYABLE_HOLD_STATUSES"/>
        </mat-chip-set>
      </td>
    </tr>

    <tr class="border">
      <td class="text-title-medium text-right px-3 border-r">Circulation item status</td>
      <td class="flex flex-col gap-y-3 p-3">
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mx-status-chip status="IN_LIBRARY" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="SHELVING" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="BINDERY" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="ON_ORDER" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="HELD" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS" subscriptText="until 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="IN_TRANSFER" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
        </mat-chip-set>
        <mat-divider/>
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mx-status-chip status="IN_REPAIR" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="IN_PROCESS" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="CLAIM_RETURNED" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS" subscriptText="on 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="CLAIM_NEVER_HAD" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS" subscriptText="on 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="CLAIM_MISSING_PARTS" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS" subscriptText="on 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
        </mat-chip-set>
        <mat-divider/>
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mx-status-chip status="CHECKED_OUT" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS" subscriptText="due 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="LOST" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS" subscriptText="since 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="MISSING" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS" subscriptText="since 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="WITHDRAWN" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS" subscriptText="on 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="UNAVAILABLE" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
          <mx-status-chip status="DAMAGED" [colors]="CIRCULATION_ITEM_STATUS_CHIP_COLORS"
                          [displayableStatusNames]="DISPLAYABLE_CIRCULATION_ITEM_STATUSES"/>
        </mat-chip-set>
      </td>
    </tr>

    <tr class="border">
      <td class="text-title-medium text-right px-3 border-r">Checkout claim type</td>
      <td class="p-3">
        <mat-chip-set class="flex flex-row justify-start items-center">
          <mx-status-chip status="CLAIMED_RETURNED" [colors]="CHECKOUT_CLAIM_TYPE_CHIP_COLORS" subscriptText="on 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CHECKOUT_CLAIM_TYPE"/>
          <mx-status-chip status="CLAIMED_NEVER_HAD" [colors]="CHECKOUT_CLAIM_TYPE_CHIP_COLORS" subscriptText="on 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CHECKOUT_CLAIM_TYPE"/>
          <mx-status-chip status="CLAIMED_MISSING_PARTS" [colors]="CHECKOUT_CLAIM_TYPE_CHIP_COLORS" subscriptText="on 04/01/2024"
                          [displayableStatusNames]="DISPLAYABLE_CHECKOUT_CLAIM_TYPE"/>
        </mat-chip-set>
      </td>
    </tr>

    <tr class="border">
      <td class="text-title-medium text-right px-3 border-r">Filter chip</td>
      <td class="p-3">
        <!-- Usually we use mat-chip-set with mat-chip for static chips and mat-chip-listbox with mat-chip-option for forms,
             but here, we use mat-chip-listbox so that click targets are allowed in the container but regular mat-chips,
             since only the remove button is clickable-->
        <mat-chip-listbox>
          <mat-chip class="border" color="background">
            <div class="flex items-center mr-[-0.75rem]">
              Filter Title
              <mx-icon-button icon="close" color="on-surface-variant" iconClasses="mat-icon-size-5" buttonClasses="size-[2rem] p-[0.375rem]"/>
            </div>
          </mat-chip>
        </mat-chip-listbox>
      </td>
    </tr>
  </table>
</mx-component-lib-section>

<mx-component-lib-section titleText="Date Picker">
  <mat-form-field appearance="outline">
    <mat-label>Pick A Date</mat-label>
    <input matInput [matDatepicker]="picker"/>
    <mat-datepicker-toggle matSuffix [for]="picker"/>
    <mat-datepicker #picker/>
  </mat-form-field>
</mx-component-lib-section>

<mx-component-lib-section titleText="Date Range Picker">
  <mx-date-range-form-field [formGroup]="dateRangeFormGroup" fieldName="dateRange" class="w-[20rem]"/>
</mx-component-lib-section>

<mx-component-lib-section titleText="Mobile Barcode Scanner">
  <mat-card class="w-[75rem]">
    <mat-card-content>
      <mx-mobile-barcode-scanner/>
    </mat-card-content>
  </mat-card>
</mx-component-lib-section>

<mx-component-lib-section titleText="Number Fields">
  <mat-card>
    <mat-card-content>
      <mx-form-row>
        <mx-number-form-field [formGroup]="numbersFormGroup" fieldName="decimalNumber" class="basis-1/2"/>
        <mx-number-form-field [formGroup]="numbersFormGroup" fieldName="integerNumber" [integerOnly]="true" class="basis-1/2"/>
      </mx-form-row>
    </mat-card-content>
  </mat-card>
</mx-component-lib-section>

<mx-component-lib-section titleText="Snack Bars">
  <mx-component-lib-snack-bars/>
</mx-component-lib-section>

<mx-component-lib-section titleText="Switch (a.k.a. Slide Toggle)">
  <mx-action-buttons>
    <mx-elevated-button [label]="allSlideTogglesChecked ? 'Deselect All' : 'Select All'" (click)="allSlideTogglesChecked = !allSlideTogglesChecked;"/>
    <mx-elevated-button [label]="allSlideTogglesDisabled ? 'Enable All' : 'Disable All'" (click)="allSlideTogglesDisabled = !allSlideTogglesDisabled;"/>
  </mx-action-buttons>

  <div class="flex flex-row gap-x-12 align-center">
    <mat-slide-toggle color="surface" [disabled]="allSlideTogglesDisabled" [checked]="allSlideTogglesChecked">surface</mat-slide-toggle>
    <mat-slide-toggle color="primary" [disabled]="allSlideTogglesDisabled" [checked]="allSlideTogglesChecked">primary</mat-slide-toggle>
    <mat-slide-toggle color="success" [disabled]="allSlideTogglesDisabled" [checked]="allSlideTogglesChecked">success</mat-slide-toggle>
    <mat-slide-toggle color="error" [disabled]="allSlideTogglesDisabled" [checked]="allSlideTogglesChecked">error</mat-slide-toggle>
  </div>
</mx-component-lib-section>

<mx-component-lib-section titleText="Textareas">
  <mx-component-lib-textarea-form-fields/>
</mx-component-lib-section>

<mx-elevated-button label="Toggle Dark Theme" (click)="toggleDarkTheme()" class="m-8"/>

<mx-component-lib-section titleText="Color Palettes">
  <mx-component-lib-color-grid figmaColorPrefix="OPAC" [currentTheme]="currentTheme" [colorAliasNames]="colorAliasNames"/>
</mx-component-lib-section>

<mx-component-lib-section titleText="Typography">
  <mat-card>
    <mat-card-content class="flex flex-col gap-2 p-2 m-4">
      <span class="text-title-large italic">DISPLAY</span>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-display-large'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-display-medium'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-display-small'}"/>

      <span class="text-title-large italic mt-8">HEADLINE</span>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-headline-large'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-headline-medium'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-headline-small'}"/>

      <span class="text-title-large italic mt-8">TITLE</span>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-title-large'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-title-medium'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-title-small'}"/>

      <span class="text-title-large italic mt-8">LABEL</span>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-label-large'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-label-medium'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-label-small'}"/>

      <span class="text-title-large italic mt-8">BODY</span>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-body-large'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-body-medium'}"/>
      <ng-container *ngTemplateOutlet="typographyRow; context: {typographyClass: 'text-body-small'}"/>
    </mat-card-content>
  </mat-card>

  <ng-template #typographyRow let-typographyClass="typographyClass">
    <div class="flex flex-row gap-3 items-center {{ typographyClass }}">
      <mat-icon class="inherit-size">emoji_people</mat-icon>
      <span>{{ typographyClass }}</span>
      <mat-icon class="inherit-size">sentiment_satisfied</mat-icon>
    </div>
  </ng-template>
</mx-component-lib-section>

<div class="h-[32rem]"></div>
